import { render } from "./ArticleConfigView.vue?vue&type=template&id=d1505014&scoped=true"
import script from "./ArticleConfigView.vue?vue&type=script&lang=js"
export * from "./ArticleConfigView.vue?vue&type=script&lang=js"

import "./ArticleConfigView.vue?vue&type=style&index=0&id=d1505014&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d1505014"

export default script